import { htmlSafe } from '@ember/template';

import type { PopupData } from 'webapp-types';
import { PromotionIdentifier } from 'webapp/enums/enums';
import { getFormattedPrice } from 'webapp/utils/number';

import BillingPromotionsGrowth2024PopupPlanUpgradeOfferComponent from 'webapp/components/billing/promotions/growth-2024/popup-plan-upgrade-offer';

import type { TrackingOriginTypeForTrialPopupOpened } from 'webapp/services/billing';

export default class BillingPopupPlanUpgradeTrialComponent extends BillingPromotionsGrowth2024PopupPlanUpgradeOfferComponent<PopupData.Billing.StartTrialPlan> {
	override promotionId = PromotionIdentifier.TRIAL_HIGHER_PLAN;
	override origin: TrackingOriginTypeForTrialPopupOpened = 'limit';

	override get targetPlan() {
		return this.popupData.targetPlan;
	}

	override get feature() {
		return this.popupData.feature;
	}

	override get trackingOriginForFeature(): TrackingOriginTypeForTrialPopupOpened | null {
		const trackingOrigin = this.popupData.trackingOrigin;
		if (this.popupData.useOriginForTrackingFeature && trackingOrigin) {
			return trackingOrigin;
		}

		return null;
	}

	get featureName() {
		const feature = this.feature;
		return (feature && this.billingService.getFeatureName(feature)) || feature || null;
	}

	get isFeatureCountable() {
		const feature = this.feature;
		return !!feature && this.targetPlan.features.isCountable(feature);
	}

	override get upgradeText() {
		if (!this.feature) {
			return htmlSafe(`Try the <span>${this.planName}</span> plan free for 14 days`);
		}

		const featureText = this.isFeatureCountable
			? `More ${this.featureName}`
			: `Feature ${this.featureName} is`;
		return htmlSafe(`${featureText} on the <span>${this.planName}</span> plan`);
	}

	override get buttonText() {
		return 'Start your 14-day free trial now';
	}

	override get noticeText() {
		const feature = this.feature;
		if (feature) {
			return `Your current plan doesn't include this.`;
		}

		return null;
	}

	override get planPrice() {
		return getFormattedPrice(this.getMonthlyPrice(this.targetPlan), 0, true);
	}

	override get previousPlanPrice() {
		return this.planPrice;
	}

	override get isPreviousPlanPriceShown() {
		return false;
	}

	override get pricingTitle() {
		return 'Plan price after your free trial ends';
	}
}
